import { LogRouteConfig } from '@/modules/to/log/LogRouteConfig';
import { SyncLogsRouteNames } from '@/modules/to/log/log.constants';

export const router = LogRouteConfig.factory([
  {
    path: `/${SyncLogsRouteNames.SYNCLOGS}/:model?/:tp_id?`,
    name: SyncLogsRouteNames.SYNCLOGS,
    component: () =>
      import(/* webpackChunkName: "synclogs-page" */ './pages/ToTpSyncLogListPage.vue'),
  },
]);
